import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip'
import { formatDate, formatLocalDateTime } from '../../../utils/dateFormat'

const DateTime = ({ jsonTime }) => (
  <Tooltip title={formatLocalDateTime(jsonTime)}>
    <div style={{ whiteSpace: 'nowrap' }}>{formatDate(jsonTime)}</div>
  </Tooltip>
)

DateTime.propTypes = {
  jsonTime: PropTypes.string.isRequired
}

export default React.memo(DateTime)
